// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"738daaaa","975":"8e17cc49","984":"03e67ace"}[chunkId] + ".chunk.js";
};